module.exports = __webpack_public_path__ + "static/media/noResultsNew.51ff15d9.svg";